import {client} from './services/client'

export  const templates = {
    namespaced:true,
    state:{
        templates:undefined,
        templatemines:undefined,
        templatefrees:undefined,
        templatenotfrees:undefined,
    },
    mutations: {
        SET_TEMPLATES (state,templates){
            state.templates = templates
        },
        SET_TEMPLATEMINES (state,marchand){
            state.templatemines = marchand
        },

        SET_TEMPLATEFREE (state,marchand){
            state.templatefrees = marchand
        },

        SET_TEMPLATENOTFREE (state,marchand){
            state.templatenotfrees = marchand
        },
    },
    actions: {
        getTemplates({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/templates/get',
                })
                    .then((response)=>{
                        let templates = response.data.templates;
                        commit('SET_TEMPLATES',templates)
                        resolve(response.data)
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })
        },
        updateTemplate({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/templates/update',
                    data:data,
                })
                    .then((response)=>{
                        let templates = response.data.templates
                        commit('SET_TEMPLATES',templates);
                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        setTemplate({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/templates/save',
                    data:data,
                })
                    .then((response)=>{
                        let templates = response.data.templates;
                        commit('SET_TEMPLATES',templates);

                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        deleteTemplate({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/templates/delete/'+id,
                })
                    .then((response)=>{
                        let templates = response.data.templates;
                        commit('SET_TEMPLATES',templates);
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
        getMarchandTemplate({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/templates/marchand/get',
                })
                    .then((response)=>{
                        let templatemines = response.data.templatemines;
                        commit('SET_TEMPLATEMINES', templatemines)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })
        },
        getMarchandTemplateFree({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/templates/free/get',
                })
                    .then((response)=>{
                        let templatefrees = response.data.templatefrees;
                        commit('SET_TEMPLATEFREE', templatefrees)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })
        },
        getMarchandTemplateNotFree({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/templates/notfree/get',
                })
                    .then((response)=>{
                        let templatenotfrees = response.data.templatenotfrees;
                        commit('SET_TEMPLATENOTFREE', templatenotfrees)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })
        },
        setAddTemplate({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/templates/setAddTemplate',
                    data:data
                })
                    .then((response)=>{
                        let templatemines = response.data.templatemines;
                        commit('SET_TEMPLATEMINES', templatemines)

                        let templatenotfrees = response.data.templatenotfrees;
                        commit('SET_TEMPLATENOTFREE', templatenotfrees)

                        let templatefrees = response.data.templatefrees;
                        commit('SET_TEMPLATEFREE', templatefrees)


                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })
        },

    },
    getters: {
        getCountries: state  => {
            return state.templates
        },
    }
};
